import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MasterLayoutComponent } from '@/app/route-components/MasterLayoutComponent';
import { FISCAL_YEAR_MIN, getCurrentFiscalYear, getFiscalYearMax } from '@/shared/lib/fiscal-year';

const masterSearchSchema = z.object({
  fiscalYear: z.coerce
    .number()
    .int()
    .min(FISCAL_YEAR_MIN)
    .max(getFiscalYearMax())
    .catch(getCurrentFiscalYear())
    .default(getCurrentFiscalYear()),
});

/**
 * マスタ管理レイアウトルート
 *
 * 第2メニュー（MasterMenu）とページコンテンツを横並びで配置する。
 * LayoutOffsetProvider で additionalLeftOffset を設定し、
 * MainPageLayout の固定ヘッダー位置を第2メニュー幅分ずらす。
 * サイドバーが hidden の場合は第2メニューも非表示になる。
 */
export const Route = createFileRoute('/_protected/master')({
  component: MasterLayoutComponent,
  validateSearch: (record) => masterSearchSchema.parse(record),
});
